<template>
    <div>
        <div
                v-b-tooltip.hover
                :title="tooltipTitle">
            <div class="text-muted">
                <i class="fa fa-map-marker"></i> {{order.techcenter.city.name}} - {{order.techcenter.company.name}}
            </div>
            <span class="badge" @click.stop="viewTechcenter" :style="{ backgroundColor: order.techcenter.color }">{{order.techcenter.address}}</span>
        </div>
    </div>
</template>
<script>
  export default{
    props: ['order'],
    computed: {
      tooltipTitle () {
        let phone = 'не указан'
        if (this.order.techcenter.phone) {
          phone = '+7' + this.order.techcenter.phone
        }
        let title = 'Номер телефона техцентра ' + phone
        if (this.order.techcenter.canView) {
          title += ' для просмотра детальной информации о техцентре кликните по бейджу с адресом ниже'
        }
        return title
      }
    },
    data () {
      return {
        loading: false,
        progressBarWidth: 0
      }
    },
    methods: {
      viewTechcenter () {
        if (this.order.techcenter.canView) {
          this.$router.push({name: 'Techcenter', params: {id: this.order.techcenter.id}})
        }
      }
    },
    created () {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// OrderTechcenterInfo.vue?72cdb6d0